import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux'
import * as Sentry from "@sentry/react";
import './index.scss';
import './index.css';
import App from './App';
import CustomErrorBoundary from './ErrorBoundary';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

import { store } from './app/store';

Sentry.init({
  dsn: "https://f7869d8caaaff734baf41efdb26fde0e@o4508687860039680.ingest.us.sentry.io/4509926619283456",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: process.env.NODE_ENV
});

const ErrorFallback = () => {
  return (
    <div className='w-screen h-screen flex flex-col justify-center items-center'>
      <p>An error has occurred</p>
      <button onClick={() => window.location.reload()}>Reload</button>
    </div>
  )
}

const AppComponent = () => {
  const [showUpdate, setShowUpdate] = useState(false);

  const onSWUpdate = (registration) => {
    registration.update();
    setShowUpdate(true);
  } 
  useEffect(() => {
    // serviceWorkerRegistration.register({ onUpdate: onSWUpdate });
  }, []);
  return (
    <>
      <App />
    </>
  )
};


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  
  <CustomErrorBoundary>
    <React.StrictMode>
      <Provider store={store}>
        <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
          <AppComponent />
        </Sentry.ErrorBoundary>
      </Provider>
    </React.StrictMode>
  </CustomErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
